<div [formGroup]="form">
    <app-ativacao-section-card
        [control]="ativoControl"
        titulo="Retenções na fonte"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Retenções na fonte ativas. A base de cálculo e as alíquotas abaixo serão aplicadas nas retenções desta natureza de operação."
        descricaoInativo="Retenções na fonte inativas. Nenhuma retenção será calculada nesta natureza de operação."
        emptyStateTitulo="Retenções na fonte desativadas"
        emptyStateDescricao="Ative as retenções na fonte acima para informar a base de cálculo padrão e as alíquotas de PIS, COFINS, CSLL, IRRF e INSS.">
    </app-ativacao-section-card>

    @if (ativoControl.value) {
    <div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
        <span>Retenções na fonte</span>
    </div>

    <div class="row g-3">
        <!-- Base de cálculo padrão -->
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Base de cálculo padrão</mat-label>
                <mat-select formControlName="idTipoBaseCalculoRetencao">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (tipo of tiposBaseCalculo; track tipo.id) {
                    <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>percent</mat-icon>
                    <span>Alíquotas de retenção (% sobre a base configurada)</span>
                </div>
                <div class="row g-3 mt-1">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Retenção PIS (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="retencaoPis">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Retenção COFINS (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="retencaoCofins">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Retenção CSLL (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="retencaoCsll">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>IRRF (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="irrf">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>account_balance</mat-icon>
                    <span>Retenção previdenciária (INSS)</span>
                </div>
                <div class="row g-3 mt-1">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota INSS (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="aliquotaInss">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Base do INSS</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="baseInss">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    }
</div>
